import { defineComponent as x, useCssVars as oe, ref as C, computed as N, onMounted as X, onUnmounted as Y, openBlock as f, createElementBlock as T, createVNode as p, unref as d, withCtx as h, createElementVNode as g, Fragment as H, renderList as q, withKeys as K, renderSlot as W, mergeProps as L, createBlock as E, withModifiers as ae, resolveDynamicComponent as Z, createCommentVNode as M, normalizeClass as O, toDisplayString as A, createTextVNode as V, normalizeProps as re, guardReactiveProps as ne, watch as ie } from "vue";
import { CdrBreakpointMd as ce, CdrBreakpointLg as de } from "@rei/cdr-tokens";
import { IconCaretLeft as ue, IconCaretRight as fe, CdrButton as me, CdrText as D, CdrLink as pe, CdrImg as _e, CdrRating as ge } from "@rei/cedar";
import { useElementHover as ve } from "@vueuse/core";
import he from "@rei/aria-announcer";
import { ScrollAreaRoot as ye, ScrollAreaViewport as we, ScrollAreaScrollbar as j, ScrollAreaThumb as J } from "radix-vue";
import Q from "lodash/debounce.js";
const Se = ["id", "data-ui"], be = ["id"], ke = /* @__PURE__ */ x({
  name: "ScrollCarousel",
  __name: "ScrollCarousel",
  props: {
    id: {},
    description: {
      default: ""
    },
    dataUi: {
      default: "scroll-carousel"
    },
    isShowingArrows: {
      type: Boolean,
      default: !0
    },
    slides: {},
    slidesToShow: {
      default: 5
    },
    slidesToScroll: {
      default: 4
    },
    slidesGap: {
      default: 0
    },
    slideExtra: {
      default: 0.25
    },
    focusSelector: {
      default: ":first-child"
    },
    viewportTabindex: {
      default: "-1"
    }
  },
  emits: ["arrowClick"],
  setup(_, {
    emit: u
  }) {
    oe((e) => ({
      "7771c087": e.slidesGap,
      "754b3f02": b.value,
      "7454a54c": e.slideExtra
    }));
    const s = u, t = _, o = C(""), v = C(null), a = C(null), l = C(null), $ = C(0), m = C(0), y = C(0), n = ve(v), w = C(!1), b = N(() => {
      const e = t.slidesToShow * t.slidesGap, i = $.value - e, r = t.slidesToShow + t.slideExtra;
      return i / r;
    });
    function z(e) {
      const i = b.value * e, r = t.slidesGap * e;
      return i + r;
    }
    function I(e) {
      var P, k;
      s("arrowClick", {
        direction: e
      });
      const i = (e === "left" ? -1 : 1) * t.slidesToScroll, r = m.value + i;
      let c;
      r < 0 ? c = 0 : c = r;
      const S = z(c), B = (P = a == null ? void 0 : a.value) == null ? void 0 : P.viewportElement.scrollLeft;
      (k = a == null ? void 0 : a.value) == null || k.viewportElement.scrollBy({
        left: S - B,
        behavior: "smooth"
      });
    }
    const R = Q(() => {
      t.slidesToShow === 1 ? o.value = `Now showing slide ${m.value + 1}` : o.value = `Now showing slides ${m.value + 1} through ${m.value + t.slidesToShow}`;
    }, 1e3), te = N(() => ["left", "right"].map((e) => {
      const i = m.value === 0, r = m.value >= t.slides.length - t.slidesToShow, c = e === "left" ? !i : !r;
      return {
        direction: e,
        icon: e === "left" ? ue : fe,
        attributes: {
          "data-ui": `scroll-carousel__arrow--${e}`,
          class: `scroll-carousel__arrow scroll-carousel__arrow--${e} ${c ? "" : "scroll-carousel__arrow--disabled"}`,
          "aria-label": `${e === "right" ? "Next" : "Previous"} Slide`,
          "aria-controls": `${t.id}-slides`,
          tabindex: 0,
          size: "large",
          disabled: !c
        }
      };
    }));
    function le(e) {
      const i = t.isShowingArrows && n.value && t.slides.length > t.slidesToShow;
      return e === "left" ? i && w.value : i;
    }
    const F = Q((e) => {
      const i = e.target, {
        scrollLeft: r
      } = i, c = t.slides.map((P, k) => z(k));
      w.value || (w.value = !0);
      const S = c.reduce((P, k) => Math.abs(k - r) < Math.abs(P - r) ? k : P), B = t.slides.findIndex((P, k) => S === c[k]);
      B !== m.value && (m.value = B), R();
    }, 50);
    function G(e, i) {
      if (e.preventDefault(), i === "left" ? y.value = y.value <= 0 ? t.slides.length - 1 : y.value - 1 : y.value = y.value >= t.slides.length - 1 ? 0 : y.value + 1, l.value) {
        const c = l.value[y.value].querySelector(t.focusSelector);
        c && c.focus();
      }
    }
    function se(e) {
      const i = e.currentTarget, r = e.relatedTarget;
      i.contains(r) || (o.value = `Showing ${t.slides.length} items. Currently on item ${m.value + 1}. Use left and right arrow keys to navigate between items.`);
    }
    function U() {
      var e;
      $.value = ((e = v.value) == null ? void 0 : e.offsetWidth) ?? 0;
    }
    return X(() => {
      U(), window.addEventListener("resize", U);
    }), Y(() => {
      window.removeEventListener("resize", U), F.cancel();
    }), (e, i) => (f(), T("div", {
      id: e.id,
      ref_key: "containerRef",
      ref: v,
      "data-ui": e.dataUi,
      class: "scroll-carousel",
      onFocusin: se
    }, [p(d(ye), {
      type: "auto",
      class: "scroll-carousel__root"
    }, {
      default: h(() => [p(d(we), {
        ref_key: "slidesRef",
        ref: a,
        class: "scroll-carousel__viewport",
        "aria-label": e.description || `${e.slides.length} items`,
        tabindex: e.viewportTabindex,
        onScroll: d(F)
      }, {
        default: h(() => [g("ul", {
          id: `${e.id}-slides`,
          class: "scroll-carousel__slides",
          "data-ui": "scroll-carousel__slides"
        }, [(f(!0), T(H, null, q(e.slides, (r, c) => (f(), T("li", {
          key: r.key,
          ref_for: !0,
          ref_key: "slidesItemsRef",
          ref: l,
          class: "scroll-carousel__slide",
          "data-ui": "scroll-carousel__slide",
          onKeydown: [i[0] || (i[0] = K((S) => G(S, "right"), ["right"])), i[1] || (i[1] = K((S) => G(S, "left"), ["left"]))]
        }, [W(e.$slots, "slide", L({
          index: c,
          ref_for: !0
        }, r.props, {
          tabindex: c === y.value ? "0" : "-1"
        }), void 0, !0)], 32))), 128))], 8, be)]),
        _: 3
      }, 8, ["aria-label", "tabindex", "onScroll"]), p(d(j), {
        class: "scroll-carousel__bar scroll-carousel__bar--vertical",
        orientation: "vertical",
        "data-state": "visible",
        "data-orientation": "vertical",
        "data-ui": "scroll-carousel__bar--vertical"
      }, {
        default: h(() => [p(d(J), {
          class: "scroll-area__thumb"
        })]),
        _: 1
      }), p(d(j), {
        class: "scroll-carousel__bar scroll-carousel__bar--horizontal",
        orientation: "horizontal",
        "data-state": "visible",
        "data-orientation": "horizontal",
        "data-ui": "scroll-carousel__bar--horizontal"
      }, {
        default: h(() => [p(d(J), {
          class: "scroll-carousel__thumb"
        })]),
        _: 1
      })]),
      _: 3
    }), (f(!0), T(H, null, q(te.value, ({
      direction: r,
      attributes: c,
      icon: S
    }) => W(e.$slots, "arrow", L({
      ref_for: !0
    }, {
      attributes: c,
      direction: r,
      icon: S
    }, {
      onClick: () => I(r)
    }), () => [le(r) ? (f(), E(d(me), L({
      key: r,
      "icon-only": !0,
      "with-background": !0,
      ref_for: !0
    }, c, {
      onClick: ae((B) => I(r), ["prevent"])
    }), {
      icon: h(() => [(f(), E(Z(S)))]),
      _: 2
    }, 1040, ["onClick"])) : M("", !0)], !0)), 256)), p(d(he), {
      message: o.value,
      class: "scroll-carousel__sr-only",
      "data-ui": "scroll-carousel__announcer"
    }, null, 8, ["message"])], 40, Se));
  }
});
const ee = (_, u) => {
  const s = _.__vccOpts || _;
  for (const [t, o] of u)
    s[t] = o;
  return s;
}, Ce = /* @__PURE__ */ ee(ke, [["__scopeId", "data-v-839dd874"]]), Te = {
  key: 0
}, $e = {
  key: 1
}, ze = {
  key: 0,
  class: "product-tile__price--compare-price"
}, Ie = /* @__PURE__ */ x({
  __name: "ProductTilePrice",
  props: {
    isRange: {
      type: Boolean
    },
    compare: {},
    base: {},
    min: {},
    max: {}
  },
  setup(_) {
    const u = _, s = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }), t = (a) => a ? s.format(a) : "", o = {
      base: t(u.base),
      min: t(u.min),
      max: t(u.max),
      compare: t(u.compare)
    }, v = (a) => (a == null ? void 0 : a.endsWith("3")) || (a == null ? void 0 : a.endsWith("9"));
    return (a, l) => (f(), E(d(D), {
      class: "product-tile__price"
    }, {
      default: h(() => [g("span", null, [a.isRange ? (f(), T("span", Te, [l[0] || (l[0] = g("span", {
        class: "sr-only"
      }, "Prices range from", -1)), g("span", {
        class: O({
          "product-tile__price--sale-price": v(o.min)
        })
      }, A(o.min), 3), l[1] || (l[1] = g("span", {
        class: "sr-only"
      }, A(" to "), -1)), l[2] || (l[2] = g("span", {
        "aria-hidden": "true"
      }, "–", -1)), g("span", null, A(o.max), 1)])) : (f(), T("span", $e, [g("span", {
        class: O({
          "product-tile__price--sale-price": v(o.base)
        })
      }, A(o.base), 3)]))]), u.compare ? (f(), T("span", ze, [l[3] || (l[3] = g("span", {
        class: "sr-only"
      }, "compared to", -1)), V(" " + A(o.compare), 1)])) : M("", !0)]),
      _: 1
    }));
  }
});
function Pe(_, u, s, t) {
  return {
    event: _,
    rrClickUrl: u,
    analyticsConfig: s,
    redirectHref: t
  };
}
const Ae = {
  class: "product-tile__image-wrapper"
}, Ne = {
  class: "product-tile__content"
}, Ee = /* @__PURE__ */ x({
  __name: "ProductTile",
  props: {
    analyticsConfig: {},
    brand: {},
    href: {
      default: ""
    },
    headingTag: {
      default: "h3"
    },
    id: {
      default: ""
    },
    name: {},
    price: {},
    rating: {},
    rrClickUrl: {},
    visible: {
      type: Boolean
    }
  },
  emits: ["recsClick"],
  setup(_, {
    emit: u
  }) {
    const s = _, t = u, o = N(() => {
      var l;
      return (l = s.name) == null ? void 0 : l.replace("&quot;", '"');
    });
    function v(l) {
      const $ = Pe(l, s.rrClickUrl, s.analyticsConfig, s.href);
      t("recsClick", $);
    }
    const a = "";
    return (l, $) => (f(), E(d(pe), {
      class: "product-tile",
      href: l.href,
      onClickOnce: v
    }, {
      default: h(() => [g("div", Ae, [p(d(_e), {
        src: `${d(a)}/media/product/${l.id}?size=300`,
        alt: o.value,
        fit: "contain",
        ratio: "1/1",
        class: "product-tile__image",
        loading: "lazy"
      }, null, 8, ["src", "alt"])]), g("div", Ne, [(f(), E(Z(l.headingTag), {
        class: "product-tile__title"
      }, {
        default: h(() => [p(d(D), {
          class: "product-tile__brand",
          tag: "span"
        }, {
          default: h(() => [V(A(l.brand), 1)]),
          _: 1
        }), p(d(D), {
          class: "product-tile__name",
          tag: "span"
        }, {
          default: h(() => [V(A(o.value), 1)]),
          _: 1
        })]),
        _: 1
      })), l.rating ? (f(), E(d(ge), {
        key: 0,
        compact: !0,
        rating: l.rating.average,
        count: l.rating.count,
        size: "small",
        class: "product-tile__rating"
      }, null, 8, ["rating", "count"])) : M("", !0), p(Ie, re(ne(l.price)), null, 16)])]),
      _: 1
    }, 8, ["href"]));
  }
});
const Re = /* @__PURE__ */ ee(Ee, [["__scopeId", "data-v-0e234376"]]), Be = ["data-placement-type"], Fe = /* @__PURE__ */ x({
  name: "RecommendationsSlider",
  __name: "RecommendationsSlider",
  props: {
    description: {
      default: ""
    },
    dynamicSizing: {
      type: Boolean,
      default: !0
    },
    tileHeadingTag: {
      default: "h3"
    },
    imgSize: {
      default: 140
    },
    items: {
      default: () => []
    },
    maxTiles: {
      default: 6
    },
    placementName: {},
    placementId: {
      default: ""
    },
    registerPlugin: {
      type: Boolean,
      default: !0
    },
    strategy: {
      default: ""
    }
  },
  emits: ["recs-click", "scrollClick"],
  setup(_, {
    emit: u
  }) {
    const s = _, t = u, o = C(s.maxTiles);
    function v(n) {
      return n !== void 0 && Array.isArray(n) && n.length > 0 ? n : [];
    }
    const a = N(() => o.value), l = N(() => v(s.items)), $ = N(() => {
      var n;
      return (n = v(s.items)) == null ? void 0 : n.map((w, b) => ({
        key: `slide_${b}`,
        props: {
          item: w,
          productImageSize: s.imgSize,
          productHeadingTag: s.tileHeadingTag
        }
      }));
    });
    function m() {
      const {
        clientWidth: n
      } = window.document.body;
      if (s.maxTiles === 6 && s.dynamicSizing)
        switch (!0) {
          case n >= Number(de):
            o.value = 5;
            break;
          case n >= Number(ce):
            o.value = 4;
            break;
          default:
            o.value = 2;
        }
    }
    function y({
      direction: n
    }) {
      const w = n === "right" ? "forwardScroll" : "backScroll", b = n === "right" ? "scroll-right" : "scroll-left", z = s.placementName.replace(/_/g, "-"), I = s.strategy.replace(/_/g, "-"), R = {
        rrPlacementName: z,
        rrStrategy: I,
        [w]: b,
        linkName: `rr_${z}_${I}_${b}`
      };
      t("scrollClick", R);
    }
    return X(() => {
      m(), window.addEventListener("resize", m);
    }), Y(() => {
      window.removeEventListener("resize", m);
    }), ie(() => s.maxTiles, () => {
      s.dynamicSizing || (o.value = s.maxTiles);
    }), (n, w) => l.value.length ? (f(), T("div", {
      key: 0,
      ref: "recs-slider-container",
      "data-placement-type": n.placementName,
      "data-loaded": "true"
    }, [g("div", null, [W(n.$slots, "heading")]), p(Ce, {
      id: n.placementId || n.placementName,
      ref: "carousel",
      description: n.description,
      slides: $.value,
      "slides-to-show": o.value,
      "slides-to-scroll": a.value,
      onArrowClick: y
    }, {
      slide: h(({
        item: b,
        productHeadingTag: z,
        tabindex: I
      }) => [p(Re, L(b, {
        "heading-tag": z,
        tabindex: I,
        onRecsClick: w[0] || (w[0] = (R) => n.$emit("recs-click", R))
      }), null, 16, ["heading-tag", "tabindex"])]),
      _: 1
    }, 8, ["id", "description", "slides", "slides-to-show", "slides-to-scroll"])], 8, Be)) : M("", !0);
  }
});
export {
  Re as ProductTile,
  Ce as ScrollCarousel,
  Fe as default
};
